import { render } from "./DistributionDetail.vue?vue&type=template&id=13a7d7b1&scoped=true"
import script from "./DistributionDetail.vue?vue&type=script&lang=js"
export * from "./DistributionDetail.vue?vue&type=script&lang=js"

import "./DistributionDetail.vue?vue&type=style&index=0&id=13a7d7b1&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a7d7b1"]])

export default __exports__